(() => {
  const categoryNav = document.querySelector('[data-ichigeki-category-nav]');

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const getFocusable = (scope) =>
    Array.from(scope.querySelectorAll(focusableSelector)).filter(
      (element) =>
        !element.hidden &&
        !element.closest('[hidden]') &&
        element.getAttribute('aria-hidden') !== 'true',
    );

  if (categoryNav) {
    const dialog = categoryNav.querySelector('[data-ichigeki-category-dialog]');
    const openButton = categoryNav.querySelector('[data-ichigeki-open-categories]');
    let restoreFocus = null;

    if (dialog && openButton) {
      const restoreDialogFocus = () => {
        document.body.classList.remove('ichigeki-category-dialog-open');
        const target = restoreFocus;
        restoreFocus = null;
        if (target?.isConnected) target.focus({ preventScroll: true });
      };

      const closeDialog = () => {
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          restoreDialogFocus();
        }
      };

      const setGroupState = (toggle, expanded) => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        toggle.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        const label = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
        if (label) toggle.setAttribute('aria-label', label);
      };

      const openDialog = () => {
        if (dialog.open) return;
        restoreFocus = document.activeElement;
        const selected = dialog.querySelector(
          '[data-category-choice][aria-current="page"], [data-theme-toggle][aria-pressed="true"]',
        );
        const selectedGroup = selected?.closest('[data-category-group]');
        if (selectedGroup) {
          const selectedToggle = selectedGroup.querySelector('[data-ichigeki-group-toggle]');
          if (selectedToggle) setGroupState(selectedToggle, true);
        }
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.body.classList.add('ichigeki-category-dialog-open');
        window.requestAnimationFrame(() => {
          getFocusable(dialog)[0]?.focus({ preventScroll: true });
        });
      };

      openButton.addEventListener('click', openDialog);
      dialog.querySelectorAll('[data-ichigeki-close-categories]').forEach((button) => {
        button.addEventListener('click', closeDialog);
      });
      dialog.querySelectorAll('[data-ichigeki-group-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          setGroupState(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });
      dialog.addEventListener('close', restoreDialogFocus);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      document.addEventListener('keydown', (event) => {
        if (!dialog.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusable(dialog);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!dialog.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

  }

  const collection = document.querySelector('[data-ichigeki-collection]');
  if (!collection) return;
  const stateKey = `ichigeki-collection:${window.location.pathname}${window.location.search}`;
  let loadedPages = 1;
  const rememberState = () => {
    if (loadedPages > 1) sessionStorage.setItem(stateKey, JSON.stringify({ loadedPages, scrollY: window.scrollY }));
  };

  const sortSelect = collection.querySelector('[data-ichigeki-sort] select');
  sortSelect?.addEventListener('change', () => {
    const target = new URL(window.location.href);
    target.searchParams.set('sort_by', sortSelect.value);
    target.searchParams.delete('page');
    window.location.assign(`${target.pathname}${target.search}${target.hash}`);
  });

  const gridContainer = () => collection.querySelector('#ProductGridContainer');

  const syncControls = () => {
    const container = gridContainer();
    const loadMore = container?.querySelector('[data-ichigeki-load-more]');
    const pagination = container?.querySelector('[data-ichigeki-pagination]');
    if (!loadMore) return;

    loadMore.hidden = false;
    if (pagination) pagination.hidden = true;
  };

  const loadNextPage = async (loadMore) => {
    if (loadMore.dataset.loading === 'true') return;
    loadMore.dataset.loading = 'true';
    loadMore.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(loadMore.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`ICHIGEKI collection page request failed: ${response.status}`);

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextCollection = nextDocument.querySelector('[data-ichigeki-collection]');
      const nextGrid = nextCollection?.querySelector('#product-grid');
      const currentGrid = gridContainer()?.querySelector('#product-grid');
      if (!nextGrid || !currentGrid) throw new Error('ICHIGEKI collection page did not include a product grid');

      currentGrid.append(...Array.from(nextGrid.children));
      const nextLoadMore = nextCollection.querySelector('[data-ichigeki-load-more]');
      if (nextLoadMore) {
        loadMore.href = nextLoadMore.href;
      } else {
        loadMore.remove();
        const pagination = gridContainer()?.querySelector('[data-ichigeki-pagination]');
        if (pagination) pagination.hidden = false;
      }
      loadedPages += 1;
      return true;
    } catch (error) {
      console.error(error);
      const pagination = gridContainer()?.querySelector('[data-ichigeki-pagination]');
      if (pagination) pagination.hidden = false;
      return false;
    } finally {
      loadMore.dataset.loading = 'false';
      loadMore.removeAttribute('aria-busy');
    }
  };

  collection.addEventListener('click', (event) => {
    const loadMore = event.target.closest('[data-ichigeki-load-more]');
    if (loadMore) {
      event.preventDefault();
      loadNextPage(loadMore);
      return;
    }
    if (event.target.closest('#product-grid .card__heading a')) {
      rememberState();
    }
  });
  window.addEventListener('pagehide', rememberState);

  const observer = new MutationObserver(syncControls);
  observer.observe(collection, { childList: true, subtree: true });
  syncControls();

  const restoreState = async () => {
    let state;
    try {
      state = JSON.parse(sessionStorage.getItem(stateKey));
    } catch {
      sessionStorage.removeItem(stateKey);
      return;
    }
    if (!state) return;
    while (loadedPages < Number(state.loadedPages)) {
      const loadMore = gridContainer()?.querySelector('[data-ichigeki-load-more]');
      if (!loadMore || !(await loadNextPage(loadMore))) break;
    }
    window.scrollTo(0, Number(state.scrollY) || 0);
    sessionStorage.removeItem(stateKey);
  };
  restoreState();
})();
